import React__default from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { Icon } from '../Icon/Icon.js';
import Loader from '../Loader/index.js';
import { IconContainer } from './Status.styles.js';
import { FEEDBACK_ICONS } from '../../constants/feedback.js';
import STATUS_FEEDBACK_TYPES from './status.constants.js';

var StatusDisplay = function StatusDisplay(_ref) {
  var type = _ref.type;
  var theme = useTheme();
  if (type === 'loading') {
    return React__default.createElement(Loader, {
      colour: theme.colours.ink.primary.main
    });
  }
  return React__default.createElement(IconContainer, {
    $type: type
  }, React__default.createElement(Icon, {
    variant: FEEDBACK_ICONS[type]
  }));
};
StatusDisplay.propTypes = {
  type: PropTypes.oneOf(Object.values(STATUS_FEEDBACK_TYPES)).isRequired
};

export { StatusDisplay, StatusDisplay as default };
//# sourceMappingURL=StatusDisplay.js.map
